import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AuthModal } from "@/components/AuthModal";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import AllGames from "@/pages/AllGames";
import News from "@/pages/News";
import StoryPage from "@/pages/StoryPage";
import Article from "@/pages/Article";
import Party from "@/pages/Party";
import PartyHost from "@/pages/PartyHost";
import PartyPlay from "@/pages/PartyPlay";
import Encyclopedia from "@/pages/Encyclopedia";
import LivingDoc from "@/pages/LivingDoc";
import PlayPage from "@/pages/PlayPage";
import QuizPage from "@/pages/QuizPage";
import Leaderboard from "@/pages/Leaderboard";
import Subscribe from "@/pages/Subscribe";
import Profile from "@/pages/Profile";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();

  // Handle Emergent Google Auth callback before normal routing (race-condition safe).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<AllGames />} />
          <Route path="/arcade" element={<CategoryPage category="arcade" />} />
          <Route path="/brain-teasers" element={<CategoryPage category="brain" />} />
          <Route path="/quizzes" element={<CategoryPage category="quiz" />} />
          <Route path="/play/:gameId" element={<PlayPage />} />
          <Route path="/quiz/:quizId" element={<QuizPage />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/party" element={<Party />} />
          <Route path="/party/host/:code" element={<PartyHost />} />
          <Route path="/party/play/:code" element={<PartyPlay />} />
          <Route path="/documentary" element={<LivingDoc />} />
          <Route path="/encyclopedia" element={<Encyclopedia />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/story/:id" element={<StoryPage />} />
          <Route path="/news/:slug" element={<Article />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <AuthModal />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
